import { useAppClippo } from '@/core';
import { useField } from 'formik';
import { useEffect } from 'react';
import { Attach } from '../Attach';

export interface FormsDeferAttachProps {
  name: string;
}

export function FormsDeferAttach(props: FormsDeferAttachProps) {
  const { name } = props;
  const [, , { setValue, setTouched }] = useField(name);

  const clippo = useAppClippo({
    defer: true,
    noPreload: true,
  });

  const {
    value: { actions },
  } = clippo;

  useEffect(() => {
    setTouched(true);
    setValue(actions, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actions]);

  return <Attach {...clippo} />;
}
